"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_MODEL_SOCIAL = exports.STATUS_COLORS = exports.GOAL_LABELS = exports.STATUS_LABELS = exports.PLATFORM_ORDER = exports.PLATFORM_ICON = exports.PLATFORM_META = void 0;
exports.getStatusLabel = getStatusLabel;
exports.getStatusColor = getStatusColor;
exports.getPlatformLabel = getPlatformLabel;
exports.getPlatformBestTime = getPlatformBestTime;
exports.formatDate = formatDate;
exports.getPostExcerpt = getPostExcerpt;
exports.getPostImageUrl = getPostImageUrl;
exports.pfBadge = pfBadge;
exports.pfBadgesRow = pfBadgesRow;
exports.PLATFORM_META = {
    facebook: { label: 'Facebook', limit: 600, bestTime: 'wt–czw 13:00–15:00' },
    instagram: { label: 'Instagram', limit: 300, bestTime: 'pon–pt 11:00 i 19:00–21:00' },
    x: { label: 'X (Twitter)', limit: 280, bestTime: 'pon–pt 8:00–10:00' },
    linkedin: { label: 'LinkedIn', limit: 700, bestTime: 'wt–czw 8:00–10:00' },
    tiktok: { label: 'TikTok', limit: 150, bestTime: 'codziennie 18:00–21:00' },
    youtube: { label: 'YouTube', limit: 200, bestTime: 'pt–nd 15:00–17:00' },
    threads: { label: 'Threads', limit: 400, bestTime: 'codziennie 12:00–14:00' },
    pinterest: { label: 'Pinterest', limit: 200, bestTime: 'pt–nd 20:00–23:00' },
};
exports.PLATFORM_ICON = {
    facebook: { icon: 'iconsminds-facebook', cls: 'pf-facebook' },
    instagram: { icon: 'iconsminds-instagram', cls: 'pf-instagram' },
    x: { icon: 'iconsminds-twitter', cls: 'pf-x' },
    linkedin: { icon: 'iconsminds-linkedin-2', cls: 'pf-linkedin' },
    tiktok: { txt: 'TT', cls: 'pf-tiktok' },
    youtube: { icon: 'iconsminds-youtube', cls: 'pf-youtube' },
    threads: { txt: '@', cls: 'pf-threads' },
    pinterest: { icon: 'iconsminds-pinterest', cls: 'pf-pinterest' },
};
exports.PLATFORM_ORDER = ['facebook', 'instagram', 'x', 'linkedin', 'tiktok', 'youtube', 'pinterest', 'threads'];
exports.STATUS_LABELS = {
    all: 'Wszystkie',
    draft: 'Szkic', scheduled: 'Zaplanowany',
    needs_review: 'Do akceptacji', published: 'Opublikowany', failed: 'Błąd',
};
exports.GOAL_LABELS = {
    sprzedaz: 'Sprzedaż / promocja', edukacja: 'Edukacja', wizerunek: 'Wizerunek marki',
    zaangazowanie: 'Zaangażowanie', ogloszenie: 'Ogłoszenie / news', rekrutacja: 'Rekrutacja',
};
exports.STATUS_COLORS = {
    draft: '#9199A8', scheduled: '#2563EB', needs_review: '#D97706',
    published: '#16A34A', failed: '#DC2626',
};
function getStatusLabel(s) { return exports.STATUS_LABELS[s] || s; }
function getStatusColor(s) { return exports.STATUS_COLORS[s] || '#9199A8'; }
function getPlatformLabel(pid) { var _a; return ((_a = exports.PLATFORM_META[pid]) === null || _a === void 0 ? void 0 : _a.label) || pid; }
function getPlatformBestTime(pid) { var _a; return ((_a = exports.PLATFORM_META[pid]) === null || _a === void 0 ? void 0 : _a.bestTime) || '-'; }
function formatDate(d) {
    if (!d)
        return '-';
    return new Date(d).toLocaleDateString('pl-PL', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}
function getPostExcerpt(post) {
    var _a, _b, _c, _d;
    const c = (_a = post.content) === null || _a === void 0 ? void 0 : _a[(_b = post.platforms) === null || _b === void 0 ? void 0 : _b[0]];
    return (((_c = c === null || c === void 0 ? void 0 : c.text) === null || _c === void 0 ? void 0 : _c.replace(/\n+/g, ' ')) || ((_d = post.brief) === null || _d === void 0 ? void 0 : _d.topic) || '').slice(0, 120);
}
function getPostImageUrl(post, pid) {
    var _a, _b;
    const platforms = pid ? [pid] : (post.platforms || []);
    for (const p of platforms) {
        const url = (_b = (_a = post.content) === null || _a === void 0 ? void 0 : _a[p]) === null || _b === void 0 ? void 0 : _b.imageFileUrl;
        if (url)
            return url;
    }
    return null;
}
/** Generates a single platform badge HTML span matching social.html's pfBadge() */
function pfBadge(pid, size = 26) {
    var _a;
    const meta = exports.PLATFORM_ICON[pid];
    const label = ((_a = exports.PLATFORM_META[pid]) === null || _a === void 0 ? void 0 : _a.label) || pid;
    const cls = (meta === null || meta === void 0 ? void 0 : meta.cls) || '';
    const inner = (meta === null || meta === void 0 ? void 0 : meta.icon) ? `<i class="${meta.icon}"></i>` : ((meta === null || meta === void 0 ? void 0 : meta.txt) || pid.slice(0, 2).toUpperCase());
    const fs = Math.round(size * 0.44);
    return `<span class="pf-badge ${cls}" style="width:${size}px;height:${size}px;font-size:${fs}px;" title="${label}">${inner}</span>`;
}
/** Generates a row of platform badge HTML spans */
function pfBadgesRow(platforms, size = 26) {
    return `<span class="pf-row">${(platforms || []).map(p => pfBadge(p, size)).join('')}</span>`;
}
const AI_MODEL_SOCIAL = { value: 'anthropic/claude-sonnet-5', label: 'Claude Sonnet 5' };
exports.AI_MODEL_SOCIAL = AI_MODEL_SOCIAL;
